import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useFetchData } from "../../hooks/useFetchData";
import Projectcard from "../../ui/Projectcard";
import DeveloperInformation from "../../ui/DeveloperInformation";
import { useTranslation } from "react-i18next";
import { TestLanguage } from "../../hooks/testLanguage";

const Projectofdeveloper = () => {
  const[selected,setSelected]=useState()
  const { id } = useParams();
  console.log(id);
  const { data } = useFetchData(
    `${process.env.REACT_APP_API_URL}developers?filter[id]=${id}`
  );
  const { t } = useTranslation();
 useEffect(() => {
    if (data?.data?.length) {
      setSelected(data.data[0]);  // أو قم بتعديلها حسب هيكل البيانات
    }
  }, [data]); 
  console.log(
    "hii",
    data?.data?.map((i) => i.projects)
  );
  return (
    <div
      style={{
        background: "#d4d4d4",
        flexGrow: 1,
        background:
          "linear-gradient(0deg, rgba(212, 212, 212, 1) 0%, rgba(255, 255, 255, 1) 100%)",
      }}
      className="container-fluid"
    >
      {data?.data?.map((item, index) => (
        <>
          <DeveloperInformation i={item} />
          {t("directions.dir") == "rtl" ? (
            <h1
              style={{
                textAlign: "center",
                direction: t("directions.dir"),
                margin: "100px",
              }}
            >
              {t("drawerProject.projects")}{" "}
              {TestLanguage(item, "developer_name")}
            </h1>
          ) : (
            <h1
              style={{
                textAlign: "center",
                direction: t("directions.dir"),
                margin: "100px",
              }}
            >
              {TestLanguage(item, "developer_name")}{" "}
              {t("drawerProject.projects")}
            </h1>
          )}

          <Projectcard i={item?.projects} selected={selected} setSelected={setSelected}/>
        </>
      ))}
    </div>
  );
};

export default Projectofdeveloper;
